import type { IFacetItem } from "../interface/algolia";

/**
 * Algolia refinementList 항목 → Shopify Filter 의 values 모양.
 *
 * 필터 화면은 Shopify Storefront 응답(Filter[])을 그리도록 만들어져 있어서,
 * Algolia facet 결과를 같은 모양으로 바꿔 넘긴다.
 */

export function toFilterValues(id: string, items: IFacetItem[], toLabel: (value: string) => string = (value) => value) {
  return items.map((item) => ({
    id: `${id}.${item.value}`,
    label: toLabel(item.value),
    count: item.count,
    input: JSON.stringify({ [id]: item.value }),
  }));
}
